import { createFileRoute } from '@tanstack/react-router'
import ClassDetails from '@/features/class/class-details'

export const Route = createFileRoute('/_authenticated/class/$classId/$moduleId')({
  component: ClassDetailsWrapper,
})

function ClassDetailsWrapper() {
  const { classId, moduleId } = Route.useParams() as { classId: string; moduleId: string }
  return <ClassDetails key={`${moduleId}-${classId}`} />
}

export default Route